import { IconCalendarMonth, IconChartBar, IconCopy, IconHandClick, IconPencil, IconTrash } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'sonner'
import { getApi, postApi } from '../../api/call.api'
import { urlApi } from '../../api/url.api'
import IconButton from '../../components/Buttons/IconButton'
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal'
import TableComponent from '../../components/DataTable/TableComponent'
import DateRange from '../../components/DateRange/DateRange'
import DropDown from '../../components/DropDown/DropDown'
import Pagination from '../../components/Pagination/Pagination'
import DateFilterInfoPopup from '../../components/Popover/DateFilterInfoPopup'
import SearchComponent from '../../components/Search/SearchComponent'
import Layout from '../../layout/Layout'
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller'
import { dateIntoYYYY_MM_DD, formatDateToShortMonthDayYear } from '../../utils/dateTimeConverter'
import LinkShareModal from '../Links/Components/LinkShareModal'
import CreatePageLinkModal from './Components/CreatePageLinkModal'
import ImportPage from './Components/ImportPage'
import TablePreview from './Components/PageTemplates/TablePreview'
import { accessCheck } from '../../utils/accessCheck'
import { accessKeys } from '../../statics/accessKeys'

const AllPages = () => {
    const sortingFilterList = [
        {
            id: null,
            name: "All"
        }, {
            id: 1,
            name: "Scan H-L",
            value: 'linkClicks,DESC'
        }, {
            id: 2,
            name: "Scan L-H",
            value: 'linkClicks,ASC'
        }
    ]
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(5);
    const [searchData, setSearchData] = useState('');
    const [date, setDate] = useState({ startDate: '', endDate: '' });
    const [sortFilter, setSortFilter] = useState(null);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });
    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    async function getList() {
        loadingShow();
        let sortingFilterLocal = sortingFilterList?.find(item => item?.name == sortFilter)
        let postData = {
            "startDate": dateIntoYYYY_MM_DD(date.startDate),
            "endDate": dateIntoYYYY_MM_DD(date.endDate)
        }
        let url = `${urlApi.getAllPages}?page=${activePage}&limit=${perPage}&`;
        if (searchData) {
            url += "search=" + searchData + "&"
        }
        if (sortingFilterLocal?.id) {
            url += `sort=${sortingFilterLocal ? sortingFilterLocal?.value : null}&`
        }
        let resp = await postApi((postData?.startDate ? postData : {}), url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data.items,
                totalCount: resp.data.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setActivePage(1);
        setDate(newDate)
    }

    function onSortingFilterChange(sort) {
        setActivePage(1)
        setSortFilter(sort)
    }

    useEffect(() => {
        getList();
        return () => {
        };
    }, [activePage, searchData, date, sortFilter]);

    function onCopy(copyText) {
        navigator.clipboard
            .writeText(copyText)
            .then(() => {
                toast.success("Link copied");
            })
            .catch(() => {
                toast.error("something went wrong");
            });
    }

    async function deleteLink(linkId) {
        loadingShow();
        let resp = await getApi(urlApi.deletePage + linkId);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            reset();
        } else {
            toast.error(resp.message);
        }
    }

    async function publishPage(pageId) {
        let resp = await getApi(urlApi.publishPage + pageId);
        if (resp.responseCode === 200) {
            getList();
            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }

    function reset() {
        setActivePage(1);
        setSearchData('');
        setDate({ startDate: '', endDate: '' });
        setSortFilter(null);
    }

    const columns = [
        {
            name: "", selector: (row) => row?.channel_name, grow: 3.2, cell: (row) => (
                <div className='flex py-2 gap-3 items-center'>
                    <div className=''>
                        <TablePreview pageData={row?.pageData} />
                    </div>
                    <div className="text-left">
                        <p className="mb-0.5 font-semibold text-sm text-[var(--black)]">{row?.linkName}</p>
                        <Link to={row?.shortLink} target='_blank'> <p className="mb-0.5 font-semibold text-primary text-sm">{row?.shortLink}</p></Link>
                        <Link to={row?.mainLink} target='_blank'><p className="mb-0.5 text-xs italic text-[var(--black)]">{row?.mainLink}</p></Link>
                        <div className="flex gap-2 flex-wrap">
                            <p className={`font-semibold text-[10px] ${row?.linkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconChartBar size={16} /> </span> {row?.linkClicks ?? "0"} engagements</p>
                            <p className={`font-semibold text-[10px] ${row?.uniqueLinkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconHandClick size={16} /> </span> {row?.uniqueLinkClicks ?? "0"} unique clicks</p>
                            <p className="font-semibold text-[10px] text-[#BDBDBD] inline-flex items-center gap-1 mb-0"> <span> <IconCalendarMonth size={16} /> </span> {formatDateToShortMonthDayYear(row?.createdAt)}</p>
                        </div>
                    </div>
                </div>
            )
        }, {
            name: "", grow: 1.5, center: "true", selector: (row) => row?.category, cell: (row) => (
                <div className="flex gap-2 items-center flex-wrap justify-center">
                    <IconButton icon={< IconCopy size={16} />} text={"Copy"} onClickFunction={() => onCopy(row?.shortLink)} />
                    <LinkShareModal shareUrl={row?.shortLink} />
                    {accessCheck(accessKeys?.viewPageDetails) && <Link to={"/page-details"} state={row} className='no-underline'>  <IconButton icon={< IconChartBar size={16} />} text={"Details"} /></Link>}
                    {accessCheck(accessKeys?.createAndEditPage) && <Link to={"/create-page/" + row?.linkId}> <IconButton icon={< IconPencil size={16} />} /></Link>}
                    {(accessCheck(accessKeys?.publishPage) && row?.publishStatus == 2) && <ConfirmationModal
                        buttonComponent={<IconButton icon={<IconHandClick size={16} />} text={"Publish Now"} cssClass={'primary-btn'} />}
                        confirmationText={"Are You Sure Want To Publish This Page?"}
                        onConfirm={() => publishPage(row?.linkId)}
                    />}
                    {accessCheck(accessKeys?.deletePage) && <ConfirmationModal buttonComponent={<IconButton icon={<IconTrash size={16} />} />} confirmationText={"Are You Sure Want To Delete This Page?"}
                        onConfirm={() => deleteLink(row?._id)}
                    />}
                </div>
            )
        }
    ];
    return (
        <Layout>
            <div className="flex mb-3 items-center gap-3 flex-wrap">
                <SearchComponent onClear={() => { document.getElementById("link-table-search").value = ""; setSearchData('') }} inputValue={searchData}
                    onSearch={() => { setSearchData(document.getElementById("link-table-search")?.value); setActivePage(1) }} inputId='link-table-search' placeholder={"Search Pages..."} />
                <DateRange onApplyClick={(date) => onDateChange(date)} date={date} cssClass={'ms-auto'} />
                {date?.startDate && <DateFilterInfoPopup />}
                <DropDown title={"Sort By"} list={sortingFilterList?.map(item => item?.name)} defaultValue={sortFilter} onSelect={(name) => onSortingFilterChange(name)} />
                {accessCheck(accessKeys?.createAndEditPage) && <CreatePageLinkModal />}
                {accessCheck(accessKeys?.convertBitlyPage) && <ImportPage callback={() => getList()} />}
            </div>
            <p className='text-[17px] font-bold mb-0 text-[var(--grey)] px-2'>Pages</p>
            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

            <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
        </Layout>
    )
}

export default AllPages